import { DividerProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

// NEW COLOR VARIANT AND DASHED PROP
declare module '@mui/material/Divider' {
  interface DividerOwnProps {
    dashed?: boolean;
  }

  interface DividerPropsColorOverrides {
    default: true;
    primary: true;
  }
}

export default function Divider(theme: Theme) {
  const rootStyles = (ownerState: DividerProps) => {
    const defaultColor = ownerState.color === 'default' || !ownerState.color;
    const primaryColor = ownerState.color === 'primary';
    const isDashed = ownerState.dashed;
    const hasChildren = ownerState.textAlign || ownerState.children;

    const defaultColorValue = theme.palette.grey[300];
    const primaryColorValue = theme.palette.primary[100];

    // When divider has children, MUI uses ::before and ::after with borderColor
    // When no children, it uses borderColor and backgroundColor on root
    return {
      ...(defaultColor && {
        borderColor: defaultColorValue,
        ...(!hasChildren && { backgroundColor: defaultColorValue }),
        ...(hasChildren && {
          '&::before, &::after': {
            borderColor: defaultColorValue,
          },
        }),
      }),
      ...(primaryColor && {
        borderColor: primaryColorValue,
        ...(!hasChildren && { backgroundColor: primaryColorValue }),
        ...(hasChildren && {
          '&::before, &::after': {
            borderColor: primaryColorValue,
          },
        }),
      }),
      ...(isDashed && {
        borderStyle: 'dashed',
        backgroundColor: 'transparent',
      }),
    };
  };

  return {
    MuiDivider: {
      defaultProps: {
        color: 'default',
      },
      styleOverrides: {
        root: ({ ownerState }: { ownerState: DividerProps }) =>
          rootStyles(ownerState),
        middle: ({
          ownerState,
        }: {
          ownerState: DividerProps;
          theme: Theme;
        }) => ({
          ...(ownerState.orientation === 'vertical' &&
            ownerState.flexItem && {
              height: '60%',
              alignSelf: 'center',
              margin: '0 4px',
            }),
        }),
      },
    },
  };
}
